import { useState, useSyncExternalStore } from 'react';
import { useT } from '@/i18n/LocaleProvider';
import { api } from '@/api/client';
import { Dialog } from '@/app/layers/Dialog';
import { formatPrice, useSubscriptionPlans } from '@/billing/useSubscriptionPlans';
import {
  emitCheckoutEvent,
  getMockCheckout,
  setMockCheckout,
  subscribeMockCheckout,
} from './paddle';
import styles from './Paywall.module.css';

/** Только mock-режим: замена Paddle overlay. «Pay» активирует подписку в mock-API, «Close» = checkout.closed. */
export function MockCheckout() {
  const t = useT();
  const state = useSyncExternalStore(subscribeMockCheckout, getMockCheckout, () => null);
  const prices = useSubscriptionPlans();
  const [busy, setBusy] = useState(false);
  if (!state) return null;
  const plan = state.plan === 'yearly' ? prices.yearly : prices.monthly;

  const close = () => {
    setMockCheckout(null);
    emitCheckoutEvent({ name: 'checkout.closed' });
  };
  const pay = async () => {
    setBusy(true);
    try {
      await api.post('/__mock/checkout/complete', { plan: state.plan });
      setMockCheckout(null);
      emitCheckoutEvent({
        name: 'checkout.completed',
        data: { data: { transaction_id: `txn_mock_${Date.now().toString(36)}` } },
      });
    } catch (error) {
      emitCheckoutEvent({ name: 'checkout.error', data: { message: (error as Error).message } });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog
      open
      onClose={busy ? () => {} : close}
      labelledBy="mock-checkout-title"
      maxWidth={400}
      elevated
    >
      <p className={styles.eyebrow}>{t('paywall.mockEyebrow')}</p>
      <h2 id="mock-checkout-title" className={styles.mockTitle}>
        {t('paywall.mockTitle')}
      </h2>
      <p className={styles.mockText}>
        {t('paywall.mockText', {
          price_id: state.params.price_id,
          price: formatPrice(plan),
          period: state.plan === 'yearly' ? t('billing.perYearShort') : t('billing.perMonthShort'),
          email: state.params.customer.email,
        })}
      </p>
      <div className={styles.actions}>
        <button type="button" className={styles.primary} onClick={() => void pay()} disabled={busy}>
          {busy ? t('paywall.paying') : t('paywall.pay')}
        </button>
        <button type="button" className={styles.ghost} onClick={close} disabled={busy}>
          {t('common.close')}
        </button>
      </div>
    </Dialog>
  );
}
